export interface NumberWithBold {
  value: number;
  is_bold?: boolean;
};

export const extractToNumbersFromNumberWithBold = (records: Record<string,NumberWithBold[]>) => {
  return Object.entries(records).reduce((acc, [key, values]) => {
    acc[key] = values.map(value => value.value);
    return acc;
  }, {} as Record<string, number[]>);
}
